var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2490_5415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7688 10.0008L19.6335 2.13602C20.1222 1.6478 20.1222 0.85566 19.6335 0.367448C19.1449 -0.121181 18.3536 -0.121181 17.865 0.367448L10.0002 8.2322L2.13504 0.367448C1.64641 -0.121181 0.8551 -0.121181 0.366471 0.367448C-0.122157 0.85566 -0.122157 1.6478 0.366471 2.13602L8.23164 10.0008L0.366471 17.8655C-0.122157 18.3537 -0.122157 19.1459 0.366471 19.6341C0.610786 19.878 0.930979 20.0001 1.25076 20.0001C1.57053 20.0001 1.89073 19.878 2.13504 19.6337L10.0002 11.7689L17.865 19.6337C18.1093 19.878 18.4295 20.0001 18.7492 20.0001C19.069 20.0001 19.3892 19.878 19.6335 19.6337C20.1222 19.1455 20.1222 18.3533 19.6335 17.8651L11.7688 10.0008Z",
    fill: "#34373E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2490_5415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ea51079811327a4f3d8f6fab63b50042.svg";
export { ForwardRef as ReactComponent };